// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import FlagReportOutline from '../_raw/ui/icon_flag_report_outline.svg';
import withIconProps from '../withIconProps';

export default withIconProps(FlagReportOutline);
